(function () {
    function formatNumber(value) {
        const number = Number(parseInt(value, 10) || 0);
        return number.toLocaleString('en-US');
    }

    function initNav() {
        const header = document.querySelector('[data-headroom]');
        const links = Array.from(document.querySelectorAll('[data-section-link]'));
        const indicator = document.querySelector('[data-nav-indicator]');
        const sectionTargets = links.map(function (link) {
            const id = (link.getAttribute('href') || '').replace(/^#/, '');
            const target = id ? document.getElementById(id) : null;

            return target ? {id: link.getAttribute('data-section-link'), target} : null;
        }).filter(Boolean);
        let lastY = window.scrollY;
        let ticking = false;

        window.addEventListener('scroll', function () {
            const y = window.scrollY;
            header?.classList.toggle('is-hidden', y > 120 && y > lastY);
            lastY = y;
            requestNavUpdate();
        }, {passive: true});

        const setCurrent = function (id) {
            links.forEach(function (link) {
                const current = link.getAttribute('data-section-link') === id;
                link.classList.toggle('is-current', current);
                link.toggleAttribute('aria-current', current);
                if (current && indicator) {
                    const navRect = indicator.parentElement.getBoundingClientRect();
                    const linkRect = link.getBoundingClientRect();
                    indicator.style.left = (linkRect.left + (linkRect.width / 2) - navRect.left) + 'px';
                }
            });
        };

        const updateCurrentSection = function () {
            const activationY = window.scrollY + (window.innerHeight * 0.5);
            const current = sectionTargets.reduce(function (active, section) {
                const sectionTop = section.target.getBoundingClientRect().top + window.scrollY;

                return sectionTop <= activationY ? section : active;
            }, sectionTargets[0]);

            if (current) setCurrent(current.id);
            ticking = false;
        };

        function requestNavUpdate() {
            if (ticking) return;

            ticking = true;
            window.requestAnimationFrame(updateCurrentSection);
        }

        window.addEventListener('resize', requestNavUpdate, {passive: true});
        window.addEventListener('hashchange', requestNavUpdate);

        requestNavUpdate();
    }

    function initReadMore() {
        document.querySelectorAll('[data-read-more]').forEach(function (button) {
            const contentID = button.getAttribute('aria-controls');
            const content = contentID ? document.getElementById(contentID) : null;

            button.setAttribute('aria-expanded', content && !content.hidden ? 'true' : 'false');
            if (content) content.setAttribute('aria-hidden', content.hidden ? 'true' : 'false');

            button.addEventListener('click', function () {
                if (!content) return;

                button.setAttribute('aria-expanded', 'true');
                content.hidden = false;
                content.setAttribute('aria-hidden', 'false');
                button.remove();

                if (window.gsap) {
                    window.gsap.from(content, {height: 0, opacity: 0, duration: 0.35, ease: 'power2.out'});
                }
            });
        });
    }

    function initLightbox() {
        const openers = Array.from(document.querySelectorAll('.has-lightbox .lightbox-opener'));
        if (!openers.length) return;

        const overlay = document.createElement('div');
        overlay.className = 'lightbox';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.innerHTML = `
            <button class="lightbox__close" type="button">Close</button>
            <button class="lightbox__control lightbox__control--prev" type="button" aria-label="Previous image">&lt;</button>
            <figure class="lightbox__figure">
                <figcaption class="lightbox__title"></figcaption>
                <img class="lightbox__image" alt="">
                <figcaption class="lightbox__caption"></figcaption>
            </figure>
            <button class="lightbox__control lightbox__control--next" type="button" aria-label="Next image">&gt;</button>
        `;
        document.body.appendChild(overlay);

        const closeButton = overlay.querySelector('.lightbox__close');
        const prevButton = overlay.querySelector('.lightbox__control--prev');
        const nextButton = overlay.querySelector('.lightbox__control--next');
        const image = overlay.querySelector('.lightbox__image');
        const title = overlay.querySelector('.lightbox__title');
        const caption = overlay.querySelector('.lightbox__caption');
        let gallery = [];
        let index = 0;
        let lastFocused = null;
        let isTransitioning = false;
        const preloadCache = new Map();

        function setText(element, text) {
            element.textContent = text || '';
            element.hidden = !text;
        }

        function updateControls() {
            const atStart = index <= 0;
            const atEnd = index >= gallery.length - 1;
            prevButton.disabled = atStart || isTransitioning;
            nextButton.disabled = atEnd || isTransitioning;
            prevButton.classList.toggle('is-disabled', atStart);
            nextButton.classList.toggle('is-disabled', atEnd);
        }

        function preloadImage(src) {
            if (!src) return Promise.resolve();
            if (preloadCache.has(src)) return preloadCache.get(src);

            const promise = new Promise(function (resolve) {
                const loader = new window.Image();
                loader.onload = resolve;
                loader.onerror = resolve;
                loader.src = src;
            });
            preloadCache.set(src, promise);
            return promise;
        }

        function preloadGallery() {
            gallery.forEach(function (opener) {
                preloadImage(opener.getAttribute('href'));
            });
        }

        function setImage(nextIndex) {
            const opener = gallery[nextIndex];
            if (!opener) return false;

            const openerImage = opener.querySelector('img');
            index = nextIndex;
            image.src = opener.getAttribute('href');
            image.alt = openerImage?.getAttribute('alt') || opener.dataset.lightboxTitle || '';
            setText(title, opener.dataset.lightboxTitle);
            setText(caption, opener.dataset.lightboxCaption);
            updateControls();
            return true;
        }

        async function showImage(nextIndex, direction) {
            const opener = gallery[nextIndex];
            if (!opener || isTransitioning) return;

            const src = opener.getAttribute('href');
            const distance = 18;

            if (!direction || !image.getAttribute('src') || !window.gsap) {
                await preloadImage(src);
                setImage(nextIndex);
                return;
            }

            isTransitioning = true;
            updateControls();

            window.gsap.killTweensOf(image);
            await new Promise(function (resolve) {
                window.gsap.to(image, {
                    x: direction * distance,
                    opacity: 0,
                    duration: 0.16,
                    ease: 'power1.out',
                    onComplete: resolve
                });
            });

            await preloadImage(src);
            setImage(nextIndex);
            window.gsap.set(image, {x: -direction * distance, opacity: 0});
            window.gsap.to(image, {
                x: 0,
                opacity: 1,
                duration: 0.22,
                ease: 'power2.out',
                onComplete: function () {
                    isTransitioning = false;
                    updateControls();
                }
            });
        }

        function openLightbox(opener) {
            const wrapper = opener.closest('.has-lightbox');
            gallery = Array.from(wrapper.querySelectorAll('.lightbox-opener'));
            lastFocused = document.activeElement;
            overlay.classList.add('is-open');
            overlay.setAttribute('aria-hidden', 'false');
            document.body.classList.add('lightbox-open');
            preloadGallery();
            showImage(gallery.indexOf(opener));
            closeButton.focus();
        }

        function closeLightbox() {
            overlay.classList.remove('is-open');
            overlay.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('lightbox-open');
            image.removeAttribute('src');
            if (window.gsap) window.gsap.set(image, {clearProps: 'opacity,transform'});
            isTransitioning = false;
            lastFocused?.focus();
        }

        function showPrevious() {
            if (index > 0) showImage(index - 1, -1);
        }

        function showNext() {
            if (index < gallery.length - 1) showImage(index + 1, 1);
        }

        openers.forEach(function (opener) {
            opener.addEventListener('click', function (event) {
                event.preventDefault();
                openLightbox(opener);
            });
        });

        closeButton.addEventListener('click', closeLightbox);
        prevButton.addEventListener('click', showPrevious);
        nextButton.addEventListener('click', showNext);
        overlay.addEventListener('click', function (event) {
            if (event.target === overlay) closeLightbox();
        });
        document.addEventListener('keydown', function (event) {
            if (!overlay.classList.contains('is-open')) return;
            if (event.key === 'Escape') closeLightbox();
            if (event.key === 'ArrowLeft') showPrevious();
            if (event.key === 'ArrowRight') showNext();
        });
    }

    function initYearGlance() {
        const block = document.querySelector('[data-block="year-glance"]');
        if (!block || !window.gsap) return;
        const stackPencil = block.querySelector('[data-stack-pencil]');
        const stack = block.querySelector('[data-stack]');
        const pencil = block.querySelector('[data-pencil]');
        const pencilRotate = block.querySelector('[data-pencil-rotate]');
        const button = block.querySelector('[data-year-compare]');
        const number = block.querySelector('[data-current][data-previous]');
        const yearLabel = block.querySelector('[data-year-current][data-year-previous]');
        let previous = false;

        function playInitialAnimation() {
            window.gsap.timeline({delay: 0.2})
                .to(stack, {y: 0, duration: 0.45, ease: 'power2.inOut'}, 0)
                .to(pencil, {y: 0, duration: 0.45, ease: 'power2.inOut'}, 0)
                .to(pencil, {y: -18, duration: 0.18, ease: 'power2.out'}, 0.34)
                .to(pencil, {y: 0, duration: 0.24, ease: 'bounce.out'}, 0.52)
                .to(pencilRotate, {rotate: 4, duration: 0.25, yoyo: true, repeat: 1}, 0.34);
        }

        window.gsap.set(stackPencil, {y: 0});
        window.gsap.set([stack, pencil], {y: 128});

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    playInitialAnimation();
                    observer.disconnect();
                });
            }, {threshold: 0.35});

            observer.observe(block.querySelector('[data-year-stack]') || block);
        } else {
            playInitialAnimation();
        }

        button?.addEventListener('click', function () {
            previous = !previous;
            const target = previous ? number.dataset.previous : number.dataset.current;
            const label = previous ? yearLabel.dataset.yearPrevious : yearLabel.dataset.yearCurrent;
            button.textContent = previous ? 'Compare to current year' : 'Compare to previous year';
            yearLabel.textContent = label;

            window.gsap.to({value: Number(number.textContent.replace(/,/g, '')) || 0}, {
                value: Number(target),
                duration: 0.4,
                ease: 'power2.inOut',
                onUpdate: function () {
                    number.textContent = formatNumber(this.targets()[0].value);
                }
            });

            const timeline = window.gsap.timeline();

            if (previous) {
                timeline
                    .to(stack, {y: 128, duration: 0.45, ease: 'power2.inOut'}, 0)
                    .to(pencil, {y: 128, duration: 0.65, ease: 'bounce.out'}, 0.1)
                    .to(pencilRotate, {rotate: 4, duration: 0.25, yoyo: true, repeat: 1}, 0.25);
                return;
            }

            timeline
                .to(stack, {y: 0, duration: 0.45, ease: 'power2.inOut'}, 0)
                .to(pencil, {y: 0, duration: 0.45, ease: 'power2.inOut'}, 0)
                .to(pencil, {y: -18, duration: 0.18, ease: 'power2.out'}, 0.34)
                .to(pencil, {y: 0, duration: 0.24, ease: 'bounce.out'}, 0.52)
                .to(pencilRotate, {rotate: 4, duration: 0.25, yoyo: true, repeat: 1}, 0.34);
        });
    }

    function initGraphs() {
        if (!window.gsap) return;
        document.querySelectorAll('[data-block="graph"]').forEach(function (graph) {
            window.gsap.from(graph.querySelectorAll('.graph-row__bar--current'), {
                scaleX: 0,
                duration: 0.7,
                ease: 'power2.out',
                stagger: 0.08
            });
            graph.querySelector('[data-compare-graph]')?.addEventListener('click', function (event) {
                const active = graph.classList.toggle('is-comparing');
                event.currentTarget.textContent = active ? 'Compare to current year' : 'Compare to previous year';
                window.gsap.to(graph.querySelectorAll('.graph-row__bar--previous'), {opacity: active ? 1 : 0, duration: 0.25});
            });
        });
    }

    function wrapTables() {
        document.querySelectorAll('main table').forEach(function (table) {
            if (table.parentElement?.classList.contains('table-wrapper')) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'table-wrapper';
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    }

    window.addEventListener('load', function () {
        Promise.all([
            document.fonts ? document.fonts.ready : Promise.resolve()
        ]).then(() => {
            document.documentElement.classList.add('loaded');
        });
        initNav();
        initReadMore();
        initLightbox();
        initYearGlance();
        initGraphs();
        wrapTables();
    });
})();

function log(x) {
    console.log(x);
}
